import ContentBlock from './ContentBlock';
import Footer from './Footer';
import Header from './Header';
import HeroBlock from './HeroBlock';
import Postlist from './Postlist';
import TextImageBlock from './TextImageBlock';
import Layout from './Layout';

export {
    ContentBlock,
    Footer,
    Header,
    HeroBlock,
    Postlist,
    TextImageBlock,
    Layout
};

export default {
    ContentBlock,
    Footer,
    Header,
    HeroBlock,
    Postlist,
    TextImageBlock,
    Layout
};
